import React, { Component } from "react";
import Auth from "../routes/Auth";
import ModalPDUpdateProduct from "./modal/ModalPDUpdateProduct";
import ModalPDDecisionsAddProduct from "./modal/ModalPDDecisionsAddProduct";
import ModalConfirmProductDelete from "./modal/ModalConfirmProductDelete";
import { batchRequest } from "../api/ApiService";
import { submitDecisions, getSubmissionData, updateSubmissionFromJournal } from "../api/SubmitDecisions";
import AbbreviatedMillionNumberFormat from "../components/ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import LoadingIndicator from "../components/ui-building-blocks/loading/LoadingIndicator";
import SubmitDecisionsButton from "../components/ui-building-blocks/buttons/submit-decisions";
import { logError } from "../services/utils";
import PDSensor from "../components/pd/decisions/PDSensor";
import ImageSensor from "./assets/ImageSensor.png";
import RoleButtons from "../components/role-buttons";
import Styled from "components/pd/style";
import Teams from "api/Teams";
import { view } from "@risingstack/react-easy-state";
import LastStepModal from '../components/get-started/last-step';
import EventEmitter from "../services/event-emitter";
import SuccessAlert from "../components/alerts/success";
import ErrorAlert from "../components/alerts/error";
import DecisionsAlert from "../components/alerts/decisions";

import IconTableHelp from "../containers/assets/icon-table-help.svg";

class PDDecisions extends Component {
  constructor(props) {
    super(props);

    let role = Auth.getRole();
    let has_access = role === "CEO" || role === "PD";
    // isOwnRole will be used to show or hide <RoleButtons />
    let isOwnRole = role === "PD";

    this.state = {
      products: {},
      product_manufactures: [],
      loading: true,
      hasAccess: has_access,
      isOwnRole,
      roleAlert: false,
      currentRound: props.currentRound,
      roundInUrl: props.roundInUrl,
      editAlert: false,
      infoAlert: false,
      activeTab: "",
      submission_data: {
        pd: {
          date: "N/A",
          unaccepted: 0
        }
      },
      submitDecisionsLoading: false,
      rounds: props.rounds,
      isPreChecked: false,
      successMessage: null,
      errorMessage: null
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showSuccessMessage = successMessage => {
    this.setState({
      successMessage,
    }, () => {
      this.hideSuccessMessage();
    });
  }

  hideSuccessMessage = () => {
    setTimeout(() => {
      this.setState({
        successMessage: null,
      });
    }, 5000);
  }

  setErrorMessage = (title, message) => {
    this.setState({
      errorMessage: {
        title,
        message,
      },
    });
  }

  hideErrorMessage = () => {
    this.setState({
      errorMessage: null,
    });
  }

  onChangeTab = activeTab => {
    this.setState({
      activeTab
    });
  };

  reloadRole = () => {
    const role = Auth.getRole();
    const hasAccess = role === "CEO" || role === "PD";
    const isOwnRole = role === "PD";

    this.setState({
      hasAccess,
      isOwnRole
    });
  };

  showEditAlert = () => {
    this.setState({
      editAlert: true
    });
  };

  hideEditAlert = () => {
    this.setState({
      editAlert: false
    });
  };

  showInfoAlert = () => {
    this.setState({
      infoAlert: true
    });
  };

  hideInfoAlert = () => {
    this.setState({
      infoAlert: false
    });
  };

  showRoleAlert = () => {
    this.setState({
      roleAlert: true
    });
  };

  hideRoleAlert = () => {
    this.setState({
      roleAlert: false
    });
  };

  submitDecisions = () => {
    this.setState({
      submitDecisionsLoading: true
    });

    submitDecisions("development", this.state.roundInUrl || this.state.currentRound, this.getSubmissionData);
  };

  getProducts() {
    let url = `${process.env.REACT_APP_API_URL}team/products/`;
    const { roundInUrl, currentRound } = this.state;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      url += `?round_lte=${roundInUrl}`;
    } else {
      url += `?round_lte=${currentRound}`;
    }

    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      url = `${url}&team_id=${temporaryUser.team_id}`;
    }

    return url;
  }

  getProductData = (product, round) => {
    if (round in product) {
      return product[round];
    }

    return {};
  };

  getProductValue = (product, key, round) => {
    if (round in product) {
      let data = product[round];

      if (key in data) {
        let value = data[key];
        if (value !== 0) {
          return value;
        }
      }
    }

    if (round - 1 > 0 && key !== "rnd_costs") {
      return this.getProductValue(product, key, round - 1);
    }

    return 0;
  };

  getProductManufactures() {
    let apiURL = `${process.env.REACT_APP_API_URL}team/product_manufactures/`;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      apiURL = `${apiURL}?team_id=${temporaryUser.team_id}`;
    }

    return apiURL;
  }

  loadProducts = () => {
    const { rounds, roundInUrl, currentRound } = this.state;

    if (rounds.length === 0) {
      this.timer = setTimeout(this.loadProducts, 1000);
      return;
    }

    const temporaryUser = Auth.getTemporaryUser();
    const roundNumber = roundInUrl || currentRound;

    const joinRequest = batchRequest([
      this.getProducts(),
      this.getProductManufactures(),
      `${process.env.REACT_APP_API_URL}games/${Auth.getGameId()}/journal/?round_number=${roundNumber}${temporaryUser ? `&team_id=${temporaryUser.team_id}` : ''}`,
    ]);

    joinRequest
      .then(res => {
        let products = {};
        const res0 = res[0].body;
        const res1 = res[1].body;

        res0.forEach(product => {
          const { uid, round } = product;

          if (!(uid in products)) {
            products[uid] = {};
          }

          let round_object = rounds.find(i => i.id === round);

          if (round_object) {
            products[uid][round_object.number] = product;
          }
        });

        let products_filtered = {};

        const currentYear = this.currentYear;
        Object.keys(products).forEach(uid => {
          const product = products[uid];

          if (currentYear in product) {
            products_filtered[uid] = product;
          }
        });

        const productUids = Object.keys(products_filtered);

        const prevActiveTab = this.state.activeTab;
        const activeTab = prevActiveTab
          ? prevActiveTab
          : productUids.length > 0
            ? productUids[0]
            : "";

        let product_manufactures = res1;
        const { currentRound, roundInUrl } = this.state;
        let active_round = currentRound;
        if (roundInUrl !== null && roundInUrl !== currentRound) {
          active_round = roundInUrl;
        }
        const round = rounds.find(i => i.number === active_round);

        if (round) {
          product_manufactures = product_manufactures.filter(
            i => i.round === round.id
          );
        }

        let isPreChecked = true;
        let history = res[2].body.filter(i => (
          i.round_number === roundNumber &&
          (i.path.startsWith('/api/team/products/') || i.path.startsWith('/api/teams/submit_development/'))
        ));

        history.sort((a, b) => {
          const dateA = new Date(a.requested_at);
          const dateB = new Date(b.requested_at);

          return dateB - dateA;
        });

        if (!history.length || history[0].path !== '/api/teams/submit_development/' || (history[0].status_code !== 200 && history[0].status_code !== 201))
          isPreChecked = false;

        this.setState({
          products: products_filtered,
          product_manufactures,
          loading: false,
          activeTab,
          isPreChecked
        });
      })
      .catch(err => {
        logError(err, "PDDecisions", "loadProducts");
      });
  };

  getSubmissionData = () => {
    this.setState({
      submitDecisionsLoading: true
    });
    const temporaryUser = Auth.getTemporaryUser();
    getSubmissionData(["pd"], temporaryUser).then(
      submission_data => {
        this.setState({
          submission_data,
          submitDecisionsLoading: false
        }, () => this.loadProducts());
      }
    );
  };

  componentDidMount() {
    this.eventemitter.on("update-submit-decisions", this.updateSubmitDecisions);
    this.getSubmissionData();
    this.loadProducts();
  }

  componentWillUnmount() {
    this.eventemitter.off("update-submit-decisions", this.updateSubmitDecisions);
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound ||
      this.state.rounds !== nextProps.rounds
    ) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds,
        },
        () => {
          this.loadProducts();
          this.reloadRole();
        }
      );
    }
  }

  updateSubmitDecisions = () => {
    const { roundInUrl, currentRound } = this.state;

    updateSubmissionFromJournal(
      ['pd'],
      roundInUrl !== null ? roundInUrl : currentRound,
      submission_data => {
        this.setState({
          submission_data,
        });
      }
    );
  }

  get showActionsButtons() {
    if (this.state.hasAccess === false) {
      return false;
    }

    if (this.props.roundShouldBeFinished === true) {
      return false;
    }

    const { roundInUrl, currentRound, rounds } = this.state;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return false;
    }

    const round = rounds.find(i => i.number === currentRound);

    if (!round) {
      return false;
    }

    return round.is_started === true && round.is_finished === false;
  }

  get currentYear() {
    const { roundInUrl, currentRound } = this.state;

    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    return current_round;
  }

  get showSubmitDecisions() {
    return this.state.loading === false && this.state.hasAccess === true;
  }

  isProductEmpty = product => {
    return Object.keys(product).length === 0;
  };

  get canAddProduct() {
    const { products } = this.state;
    return Object.keys(products).length < 4;
  }

  getRnDCosts = (product, currentYear) => {
    return -1 * this.getProductValue(product, "rnd_costs", currentYear);
  };

  onShowCreateProductModal = () => {
    if (this.state.hasAccess === true) {
      window.$("#myModalPDDecisionsProduct").data("bs.modal", null);
      window.$("#myModalPDDecisionsProduct").modal("show");
    } else {
      this.showRoleAlert();
    }
  };

  closeCreateProductModal = () => {
    window.$("#myModalPDDecisionsProduct").modal("hide");
  };

  render() {
    const {
      location,
      router,
      currentRound: round,
    } = this.props;
    const {
      products,
      isOwnRole,
      activeTab,
      roleAlert,
      editAlert,
      infoAlert,
      submission_data,
      submitDecisionsLoading,
      loading,
      hasAccess,
      product_manufactures,
      rounds,
      isPreChecked,
      successMessage,
      errorMessage
    } = this.state;
    const currentYear = this.currentYear;
    const showActionsButtons = this.showActionsButtons;
    const showSubmitDecisions = this.showSubmitDecisions;
    const canAddProduct = this.canAddProduct;

    let currentProduct = null;
    let isCurrentProductEmpty = true;
    let currentProductData = {};
    if (products && activeTab in products) {
      currentProduct = products[activeTab];
      isCurrentProductEmpty = this.isProductEmpty(currentProduct);
      currentProductData = this.getProductData(currentProduct, currentYear);
    }

    const teamColor = Teams.currentTeamColor();

    return (
      <Styled.BodyWrapper>
        <LastStepModal
          location={location}
          router={router}
          url={`/decisions/product-development?round=${round}`}
        />
        {roleAlert && (
          <ErrorAlert
            title="Error | Not Authorized"
            message="You are not authorized to make decisions for this role."
            onHide={this.hideRoleAlert}
          />
        )}
        {editAlert && (
          <ErrorAlert
            title="You cannot modify this product"
            message="To modify a product, operations need to cancel the production of this product first. Please follow up with Operations."
            onHide={this.hideEditAlert}
          />
        )}
        {infoAlert && (
          <DecisionsAlert
            type="info"
            title="Release Date"
            message="Refers to the date when your product moves from design to manufacturing. All 4 of your product’s features must be released for production to begin of that product."
            buttonText="Done"
            onHide={this.hideInfoAlert}
          />
        )}
        <Styled.TitleWrapper>
          <Styled.Title>
            Product Management
            {isOwnRole && <RoleButtons type="product_development" />}
          </Styled.Title>
          {showActionsButtons === true && showSubmitDecisions === true && (
            <SubmitDecisionsButton
              id="product-development-submit-decisions"
              tooltipPlacement="bottom"
              data={submission_data.pd}
              isLoading={submitDecisionsLoading}
              onClick={this.submitDecisions}
              buttonComponent={Styled.SubmitDecisionButton}
              isPreChecked={isPreChecked}
            />
          )}
        </Styled.TitleWrapper>

        <LoadingIndicator loading={loading} />

        {successMessage && <SuccessAlert
          message={successMessage}
        />}
        {errorMessage && <ErrorAlert
          title={errorMessage.title}
          message={errorMessage.message}
          onHide={this.hideErrorMessage}
        />}
        {rounds && rounds.length > 0 &&
          <Styled.ProductTabs>
            {Object.keys(products).map((uid, i) => {
              const productRounds = Object.values(products[uid]);
              const productName = productRounds.length > 0 ? productRounds[0].name : '';

              return (
                <Styled.ProductTab
                  key={i}
                  isActive={activeTab === uid}
                  onClick={() => this.onChangeTab(uid)}
                >
                  {productName}
                </Styled.ProductTab>
              );
            })}
            {showActionsButtons === true && canAddProduct === true && (
              <Styled.ProductTab
                id="add-product"
                isLink={true}
                onClick={this.onShowCreateProductModal}
              >
                Add Product
                <Styled.AddProductIcon>+</Styled.AddProductIcon>
              </Styled.ProductTab>
            )}
            {showActionsButtons === true && canAddProduct === true && (
              <ModalPDDecisionsAddProduct
                reloadProducts={this.loadProducts}
                getSubmissionData={this.getSubmissionData}
                products={products}
                closeCreateProductModal={this.closeCreateProductModal}
                showSuccessMessage={this.showSuccessMessage}
              />
            )}
          </Styled.ProductTabs>}

        {currentProduct && rounds && rounds.length > 0 && (
          <Styled.ProductContainer>
            <Styled.RNDCostsContainer>
              <Styled.ProductColumnName>R&D Costs</Styled.ProductColumnName>
              <Styled.RNDCostsRow>
                <Styled.RNDCostsValue>
                  <AbbreviatedMillionNumberFormat
                    value={this.getRnDCosts(currentProduct, currentYear)}
                    prefix="$"
                    forceConvert={true}
                  />
                </Styled.RNDCostsValue>
                {isCurrentProductEmpty === false && (
                  <PDSensor
                    image={ImageSensor}
                    product={currentProduct}
                    currentRound={currentYear}
                    rounds={rounds}
                    showReleaseDate={false}
                    showImage={true}
                    showAge={false}
                    ImageComponent={Styled.SensorImage}
                    ImageWrapperComponent={Styled.SensorWrapper}
                  />
                )}
              </Styled.RNDCostsRow>
              <Styled.RNDCostsRow>
                <Styled.EmptyColumn />
                {isCurrentProductEmpty === false && (
                  <PDSensor
                    product={currentProduct}
                    currentRound={currentYear}
                    rounds={rounds}
                    showReleaseDate={false}
                    showImage={false}
                    showAge={true}
                    AgeComponent={Styled.Age}
                  />
                )}
              </Styled.RNDCostsRow>
            </Styled.RNDCostsContainer>
            <Styled.FeaturesContainer>
              <Styled.ProductColumnName addVerticalAlign={true}>
                Features
                {showActionsButtons === true && (
                  <span>
                    <ModalPDUpdateProduct
                      product={currentProductData}
                      reloadProducts={this.loadProducts}
                      hasAccess={hasAccess}
                      showRoleAlert={this.showRoleAlert}
                      product_manufactures={product_manufactures}
                      showEditAlert={this.showEditAlert}
                      getSubmissionData={this.getSubmissionData}
                      showSuccessMessage={this.showSuccessMessage}
                      setErrorMessage={this.setErrorMessage}
                    />
                    <ModalConfirmProductDelete
                      product={currentProductData}
                      reloadProducts={this.loadProducts}
                      hasAccess={hasAccess}
                      showRoleAlert={this.showRoleAlert}
                      product_manufactures={product_manufactures}
                      showEditAlert={this.showEditAlert}
                      getSubmissionData={this.getSubmissionData}
                      showSuccessMessage={this.showSuccessMessage}
                      setErrorMessage={this.setErrorMessage}
                    />
                  </span>
                )}
              </Styled.ProductColumnName>
              <Styled.ProductParameterRow>
                <Styled.ProductParameterName>
                  Resolution
                </Styled.ProductParameterName>
                <Styled.SliderWrapper>
                  <Styled.SliderInner
                    background={teamColor}
                    rank={currentProduct[currentYear]["pixels_rank"]}
                  />
                  <Styled.SliderGap
                    background={teamColor}
                    rank={currentProduct[currentYear]["pixels_rank"]}
                  >
                    {currentProduct[currentYear]["pixels_rank"]}
                  </Styled.SliderGap>
                </Styled.SliderWrapper>
              </Styled.ProductParameterRow>
              <Styled.ProductParameterRow>
                <Styled.ProductParameterName>
                  Sensitivity
                </Styled.ProductParameterName>
                <Styled.SliderWrapper>
                  <Styled.SliderInner
                    background={teamColor}
                    rank={currentProduct[currentYear]["sensitivity_rank"]}
                  />
                  <Styled.SliderGap
                    background={teamColor}
                    rank={currentProduct[currentYear]["sensitivity_rank"]}
                  >
                    {currentProduct[currentYear]["sensitivity_rank"]}
                  </Styled.SliderGap>
                </Styled.SliderWrapper>
              </Styled.ProductParameterRow>
              <Styled.ProductParameterRow>
                <Styled.ProductParameterName>Power</Styled.ProductParameterName>
                <Styled.SliderWrapper>
                  <Styled.SliderInner
                    background={teamColor}
                    rank={currentProduct[currentYear]["power_rank"]}
                  />
                  <Styled.SliderGap
                    background={teamColor}
                    rank={currentProduct[currentYear]["power_rank"]}
                  >
                    {currentProduct[currentYear]["power_rank"]}
                  </Styled.SliderGap>
                </Styled.SliderWrapper>
              </Styled.ProductParameterRow>
              <Styled.ProductParameterRow>
                <Styled.ProductParameterName>
                  Temperature
                </Styled.ProductParameterName>
                <Styled.SliderWrapper>
                  <Styled.SliderInner
                    background={teamColor}
                    rank={currentProduct[currentYear]["temp_range_rank"]}
                  />
                  <Styled.SliderGap
                    background={teamColor}
                    rank={currentProduct[currentYear]["temp_range_rank"]}
                  >
                    {currentProduct[currentYear]["temp_range_rank"]}
                  </Styled.SliderGap>
                </Styled.SliderWrapper>
              </Styled.ProductParameterRow>
            </Styled.FeaturesContainer>
            <Styled.ReleaseContainer>
              <Styled.ProductColumnName>Release Date <Styled.HelpIcon src={IconTableHelp} onClick={this.showInfoAlert} /></Styled.ProductColumnName>
              <Styled.ReleaseDate>
                {isCurrentProductEmpty === false && (
                  <PDSensor
                    product={currentProduct}
                    currentRound={currentYear}
                    rounds={rounds}
                    showReleaseDate={true}
                    showImage={false}
                    showAge={false}
                    duration_field="pixels_duration"
                  />
                )}
              </Styled.ReleaseDate>
              <Styled.ReleaseDate>
                {isCurrentProductEmpty === false && (
                  <PDSensor
                    product={currentProduct}
                    currentRound={currentYear}
                    rounds={rounds}
                    showReleaseDate={true}
                    showImage={false}
                    showAge={false}
                    duration_field="sensitivity_duration"
                  />
                )}
              </Styled.ReleaseDate>
              <Styled.ReleaseDate>
                {isCurrentProductEmpty === false && (
                  <PDSensor
                    product={currentProduct}
                    currentRound={currentYear}
                    rounds={rounds}
                    showReleaseDate={true}
                    showImage={false}
                    showAge={false}
                    duration_field="power_duration"
                  />
                )}
              </Styled.ReleaseDate>
              <Styled.ReleaseDate>
                {isCurrentProductEmpty === false && (
                  <PDSensor
                    product={currentProduct}
                    currentRound={currentYear}
                    rounds={rounds}
                    showReleaseDate={true}
                    showImage={false}
                    showAge={false}
                    duration_field="temp_range_duration"
                  />
                )}
              </Styled.ReleaseDate>
            </Styled.ReleaseContainer>
          </Styled.ProductContainer>
        )}
      </Styled.BodyWrapper>
    );
  }
}

export default view(PDDecisions);



// WEBPACK FOOTER //
// ./src/containers/PDDecisions.js